export default __webpack_public_path__ + "static/media/copyrigth-footer.9a8c3150.svg";